<template>
  <div class="User-container">
    <div style="margin: 10px 0">
      <!--检索部分-->
      <el-input style="width: 200px;" placeholder="请输入用户名"
                v-model="send.name"></el-input>
      <el-button class="ml-10" type="primary" @click="selectListPage">
        搜索<i class="el-icon-search"></i>
      </el-button>
      <el-button type="warning" @click="reset">
        重置<i class="el-icon-refresh"></i>
      </el-button>
      <!--检索部分结束-->

      <!--新增与删除-->
      <el-button type="primary" @click="insertWindow">新增<i class="el-icon-circle-plus-outline"></i>
      </el-button>
      <el-popconfirm
          class="ml-10"
          confirm-button-text="确定"
          cancel-button-text="取消"
          icon="el-icon-info"
          icon-color="red"
          title="确认要批量删除吗？"
          @confirm="confirmRemoveIdList">
        <el-button type="danger" slot="reference">批量删除<i
            class="el-icon-remove-outline"></i>
        </el-button>
      </el-popconfirm>
      <el-upload style="display: inline-block"
                 :action="'https://'+WHITE_IP+'/user/list_import'"
                 name="multipartFile"
                 :show-file-list="false"
                 accept="xlsx"
                 :on-success="onImportSuccess">
        <!-- <el-button type="primary" class="ml-10">导入<i class="el-icon-upload2"></i></el-button>-->
      </el-upload>
      <el-button type="primary" class="ml-10" @click="list_export">导出<i class="el-icon-download"></i></el-button>
    </div>

    <!--表格部分-->
    <el-table :data="list" boder stripe
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              border
              width="220"
              @selection-change="onSelectChange"
              :header-cell-class-name="headerBg">
      <el-table-column type="selection" width="60"></el-table-column><!--选择框-->
      <!--      <el-table-column prop="id" label="ID"></el-table-column>-->

      <el-table-column type="index" :index="hIndex" label="序号" width="80"/>

      <el-table-column prop="avatar" label="头像">
        <template v-slot="scope"><!--处理展示图片-->
          <div style="display: flex;align-items: center; justify-content: center;">
            <el-image style="width: 40px;height: 40px;" v-if="scope.row.avatar"
                      :src="scope.row.avatar" :preview-src-list="[scope.row.avatar]">
            </el-image>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="nick" label="昵称"></el-table-column>

      <el-table-column prop="name" label="用户名"></el-table-column>

      <el-table-column prop="role" label="角色">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.role==='管理员'">{{ scope.row.role }}</el-tag>
          <el-tag type="primary" v-if="scope.row.role==='人工智能'">{{ scope.row.role }}</el-tag>
          <!--          <el-tag type="success" v-if="scope.row.role==='小程序'">{{ scope.row.role }}</el-tag>-->
        </template>
      </el-table-column>

      <el-table-column prop="phone" label="手机"></el-table-column>

      <el-table-column prop="createTime" label="注册时间"></el-table-column>

      <el-table-column prop="recharge" label="充值记录"></el-table-column>
      <el-table-column prop="consume" label="消费记录"></el-table-column>
      <el-table-column prop="balance" label="剩余次数"></el-table-column>


      <el-table-column label="操作" width="300">
        <template #default="scope">

          <el-button type="success" @click="updateWindow(scope.row)">编辑<i
              class="el-icon-edit"></i></el-button>

          <el-popconfirm
              class="ml-10"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="确认要删除吗？"
              @confirm="confirmDelete(scope.row.id)">
            <el-button type="danger" slot="reference">删除<i
                class="el-icon-remove-outline"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!--分页部分-->
    <div class="pd-10">
      <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :page-sizes="[10, 15, 20, 50]"
          :current-page="send.currentPage"
          :page-size="send.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="send.total">
      </el-pagination>
    </div>

    <!--新增或修改弹窗-->
    <el-dialog title="用户信息" :visible.sync="sendFormFlag" :close-on-click-modal="false">
      <el-form label-width="120px" size="small">
        <el-form-item label="头像">
          <el-upload class="avatar-uploader"
                     name="multipartFile"
                     :action="'https://'+WHITE_IP+'/document/upload'"
                     list-type="picture"
                     :on-success="onSuccessAvatar">
            <el-button type="primary">修改用户头像</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item label="昵称">
          <el-input v-model="sendForm.nick" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="用户名">
          <el-input v-model="sendForm.name" autocomplete="off"></el-input>
        </el-form-item>

        <!--角色的选择-->
        <el-form-item label="角色">
          <el-select clearable v-model="sendForm.role" placeholder="请选择角色" style="width: 100%;">
            <el-option v-for="item in roleList" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="手机">
          <el-input v-model="sendForm.phone" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="充值记录">
          <el-input v-model="sendForm.recharge" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="消费记录">
          <el-input v-model="sendForm.consume" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="剩余次数">
          <el-input v-model="sendForm.balance" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmInsertOrUpdate">确 定</el-button>
        <el-button @click="sendFormFlag = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {WHITE_IP} from "../../public/config";
import router from "@/js_router/router";

export default {
  name: "User",
  data() {
    return {
      WHITE_IP: WHITE_IP, // ip地址
      list: [], // 该页面主列表
      roleList: [], // 角色列表
      stuCourseList: [], // 学生课程列表
      stuCourseFlag: false, // 是否显示学生课程列表
      courseList: [], // 课程列表
      showCourseFlag: false, // 是否展示课程列表
      headerBg: 'headerBg',
      send: {  // 发送数据
        currentPage: 1,
        pageSize: 10,
        total: 0,
        name: '',
        nick: ''
      },
      sendForm: {
        removeIdList: []
      }, // 新增发送数据
      sendFormFlag: false, // 是否展示新增发送数据
    }
  },
  //------------------------
  created() {
    // 请求分页数据
    this.selectListPage()
  },
  methods: {
    hIndex(index) {
      // 当前页数 - 1 * 每页数据条数 + index + 1 （ index 是索引值，从0开始）
      return (this.send.currentPage - 1) * this.send.pageSize + index + 1
    },
    onSuccessAvatar(res) {
      this.sendForm.avatar = res; // 这个方法就决定了哪个字段用图片
    },
    /*导入成功*/
    onImportSuccess() {
      this.$message.success("文件导入成功")
      this.selectListPage()
    },
    /*导出*/
    list_export() {
      window.open(`https://${WHITE_IP}/user/list_export`)
    },
    /*重置函数*/
    reset() {
      this.send.name = ''
      this.selectListPage()
    },
    /*当前页变化时*/
    onCurrentChange(currentPage) {
      this.send.currentPage = currentPage
      this.selectListPage()
    },
    /*每页条数变化时*/
    onSizeChange(pageSize) {
      this.send.pageSize = pageSize
      this.selectListPage()
    },
    /*分页查询*/
    selectListPage() {
      this.$http.post("/user/list_page", this.send).then(res => {
        if (res.data.code === "200") {
          this.send.total = res.data.object.total
          this.list = res.data.object.data
        } else {
          this.$message.error('查询失败，' + res.data.code)
          router.push("/login")
        }
      })
      // 顺便获取下角色集合roleList
      this.$http.post("role/list_all", {}).then(res => {
        //alert(JSON.stringify(res.data.object))
        this.roleList = res.data.object
      })
    },
    /*复选框变化时*/
    onSelectChange(val) {
      this.sendForm.removeIdList = val
    },
    /*确认批量删除*/
    confirmRemoveIdList() {
      if (this.sendForm.removeIdList === undefined) {
        return
      }
      this.sendForm.removeIdList = this.sendForm.removeIdList.map(v => v.id)  // [{},{},{}] =>[1,2,3]
      this.$http.post("user/list_delete", this.sendForm).then(res => {
        if (res.data.code === "200") {
          this.$message.success('批量删除成功')
        } else {
          this.$message.error('批量删除失败，' + res.data.message)
        }
        this.selectListPage()
      })
      this.selectListPage()
    },
    /*确认删除*/
    confirmDelete(id) {
      this.sendForm.id = id
      this.$http.post("/user/delete", this.sendForm).then(res => {
        if (res.data.code === "200") {
          this.$message.success('删除成功')
        } else {
          this.$message.error('删除失败，' + res.data.message)
        }
        this.selectListPage()
      })
    },
    /*修改窗口*/
    updateWindow(row) {
      this.sendFormFlag = true
      this.sendForm = JSON.parse(JSON.stringify(row))
    },
    /*确认新增或修改*/
    confirmInsertOrUpdate() {
      this.sendFormFlag = false
      this.$http.post("/user/insertOrUpdate", this.sendForm).then(res => {
        console.log(res.data)
        if (res.data.code === "200") {
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败，' + res.data.message)
        }
        this.selectListPage()
      })
    },
    /*新增窗口*/
    insertWindow() {
      this.sendFormFlag = true
      this.sendForm = {} // 初始化新增空白表单
    },
  }
}
</script>

<style scoped>
</style>
